import * as remoteAction from "../remoteAction";

interface GetRewardStats {
  campaignId: string;
  email: string;
}

export type GetRewardStatsActionSuccess = remoteAction.MerchantRemoteResponse<
  "GET_REWARD_STATS_SUCCESS",
  any
>;
export type GetRewardStatsActionFailure = remoteAction.MerchantRemoteResponse<
  "GET_REWARD_STATS_FAILURE",
  any
>;
export type GetRewardStatsActionRequest = remoteAction.MerchantRemoteResponse<
  "GET_REWARD_STATS_REQUEST",
  any
>;

export interface GetRewardStatsAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_REWARD_STATS_REQUEST";
    success: "GET_REWARD_STATS_SUCCESS";
    failure: "GET_REWARD_STATS_FAILURE";
  };
}

export function getRewardStats(data: GetRewardStats): GetRewardStatsAction {
  return {
    data,
    method: "GET",
    params: data,
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_REWARD_STATS_FAILURE",
      request: "GET_REWARD_STATS_REQUEST",
      success: "GET_REWARD_STATS_SUCCESS",
    },
    https: true,
    url: "/analytics/advocate-dashboard",
  };
}
